/**
 * Shared GTM container for www and business. Push the site id before the
 * container script runs so tags can tell the two sites apart.
 */
type GtmWindow = Window & {
  dataLayer?: Array<Record<string, unknown>>;
};

export default defineNuxtPlugin({
  name: 'gtm-site-context',
  enforce: 'pre',
  setup() {
    const siteId = useRuntimeConfig().public.siteId || 'www';
    const gtmWindow = window as GtmWindow;
    const dataLayer = gtmWindow.dataLayer ?? [];
    gtmWindow.dataLayer = dataLayer;
    dataLayer.push({ site_id: siteId });
  },
});
